export default "__VITE_ASSET__DcxmOIK6__";